import React, { useEffect, useState } from "react";
import TableReportedIssues, { AvatarCell, SelectColumnFilter, StatusPill, ImageCell,ProductCell  } from "./TableReportedIssues"; // new
import { getAuthorization } from "../../../axios/AxiosAut";

function TableDataissues() {

  const [Data, setData] = useState([]);
  const getTableData = () => {
    getAuthorization()
      .get(`dashboard/management/list_recent_reported_issues/`)
      .then((res) => {
        console.log("table data issues", res.data
        );
        setData(res.data
          );
      })
      .catch((err) => {
        console.log("err", err);
      });
  };
  useEffect(() => {
    getTableData();
    console.log("Dataissues....", Data);
  }, []);

  const data = [
    {
      status: "Return",
      id: "#1345cdvbd",
      issue: "warehouse 2",
      datereport:"25-oct-2022",
      
    },
    {
      status: "open",
      id: "#23232cbedf",
      issue: "warehouse 1",
      datereport:"25-oct-2022",

    },
    {
      status: "open",
      id: "#334434erer",
      issue: "warehouse 1",
      datereport:"25-oct-2022",

    },
    {
      status: "open",
      id: "#43454fcedfd",
      issue: "warehouse 2",
      datereport:"25-oct-2022",

    },
  ];

  const columns = React.useMemo(
    () => [

      {
        Header: "ID",
        accessor: "id",
      },
      {
        Header: "Issue",
        accessor: "issue",
      },
      {
        Header: "Item/Assembly",
        accessor: "name",
      },
   
     
      
     
      {
        Header: "Date Reported",
        accessor: "end_date",
       
       
      },
      {
        Header: "Status",
        accessor: "status",
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: (value) => (
          <div>
         

          <button className="ml-2 mt-3"
          >
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
                fill="#1F78B4"
              />
            </svg>
          </button>
          </div>
        ),
      },
    
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <TableReportedIssues
            columns={columns}
            data={Data == undefined ? [] : Data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default TableDataissues;
